import React, { useState } from "react";
import { View } from "react-native";
import AccountVerification from "./AccountVerification";
import Forgot from "./Forgot";
import Loading from "./Loading";
import SignIN from "./SignIN";
import SignUP from "./SignUP";

function AuthContainer() {
  const [loading, setLoading] = useState(false);
  const [verifyUserId, setVerifyUserId] = useState(null);
  const [showComp, setShowComp] = useState("signin");

  const compnts = {
    signin: (
      <SignIN
        onCreateAccountPress={() => setShowComp("register")}
        onForgotPress={() => setShowComp("forgot")}
        onLoadingChange={setLoading}
        color="#000000"
      />
    ),
    register: (
      <SignUP
        onLoadingChange={setLoading}
        color="#000000"
        onSignInPress={() => setShowComp("signin")}
        onVerifyUser={(user) => {
          setVerifyUserId(user._id);
        }}
      />
    ),
    forgot: (
      <Forgot
        onLoadingChange={setLoading}
        close={true}
        onSuccess={() => setShowComp("signin")}
        onClose={() => setShowComp("signin")}
      />
    ),
  };

  return (
    <>
      {verifyUserId ? (
        <AccountVerification
          userId={verifyUserId}
          onSuccess={() => {
            setShowComp("signin");
            setVerifyUserId(null);
          }}
          onClose={() => {
            setShowComp("signin");
            setVerifyUserId(null);
          }}
        />
      ) : (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          {compnts[showComp]}
          {loading ? <Loading spinner /> : null}
        </View>
      )}
    </>
  );
}

export default AuthContainer;
